import React, {useState, useEffect} from 'react'
import {MDBBtn, MDBListGroup, MDBListGroupItem, MDBNavbar, MDBNavbarBrand,MDBBadge} from "mdbreact";
import classes from './LeftNavBar.module.css'
import {Trans} from "react-i18next";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import logo from "../../Assets/logo.png";
import {SUPPORTED_FUNCTIONS} from "../../Utils/FunctionList";

const LeftNavBar = (props) => {

    useEffect(() => {
        console.log(props)
    }, [])

    return (
        <div className={classes.LeftNavBar}>
            <div className={classes.Top}>
                <MDBNavbarBrand className={classes.Branding}>
                    <Link to={{pathname: '/'}}>
                        <img src={"https://mewesearcher.com/logo48.png"} alt={'mewe, search mewe page'}/>
                    </Link>
                </MDBNavbarBrand>
               <div className={classes.Topic}>
                   <Trans>LeftNavBar.title</Trans>
               </div>
                <span>
                     <Trans>LeftNavBar.description</Trans>
                </span>
            </div>

            <div className={classes.Nav}>
                <MDBListGroup className={classes.ListGroup}>
                    <Link to={'/'} alt={'home page'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <Trans>LeftNavBar.homepage</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <Link to={'/newest'} alt={'最新加入'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/newest' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <MDBBadge color="danger">New</MDBBadge>   <Trans>LeftNavBar.newest</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <Link to={'/search'} alt={'search'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/search' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <Trans>LeftNavBar.search</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <Link to={'/list'} alt={'list category'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/list' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <Trans>LeftNavBar.list-category</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <Link to={'/tips'} alt={'list category'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/tips' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <Trans>LeftNavBar.tips</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <Link to={'/about'} alt={'about'}>
                        <MDBListGroupItem
                            className={props.location.pathname === '/about' ? classes.ListGroupItemSelect : classes.ListGroupItem}>
                            <Trans>LeftNavBar.about-us</Trans>
                        </MDBListGroupItem>
                    </Link>

                    <MDBListGroupItem
                        className={ classes.ListGroupItem}
                        onClick={() => {
                            props.setModalController({
                                type: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                typeOfModal: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                isModalOpen: true,
                                metadata: {itemID: "feedback homepage"}
                            })
                        }}
                    >
                        <Trans>BottomApp.feedback</Trans>
                    </MDBListGroupItem>

                </MDBListGroup>
            </div>

        </div>
    )
}
const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}

const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default enhance(withRouter(LeftNavBar))